import { createSignal, onMount } from "solid-js";

export default function createInitial() {
  const [initial, setIntial] = createSignal(true);

  onMount(() => {
    requestAnimationFrame(() => {
      setIntial(false);
    });
  });

  return initial;
}
